// styles
import "./styles.scss";

import ellipse1 from "../../assets/images/ellipse-1.svg";
import ellipse2 from "../../assets/images/ellipse-2.svg";
import ellipse3 from "../../assets/images/ellipse-3.svg";
import QueryForm from "./queryForm";

function QuerySec({ heading, description, history }) {
  return (
    <>
      <div className="query-sec-container" id="contactus">
        <div className="container">
          <div className="row">
            <div className="col-12 col-md-12 col-lg-6">
              <div className="content-box relative">
                <img
                  className="ellipse top absolute"
                  src={ellipse2}
                  alt="ellipse"
                />
                <div className="heading text-white">{heading}</div>
                <div className="description text-white">{description}</div>
                <img
                  className="ellipse left absolute"
                  src={ellipse1}
                  alt="ellipse"
                />
              </div>
            </div>
            <div className="col-12 col-md-12 col-lg-6">
              <div className="form-box">
                <img
                  className="ellipse right absolute"
                  src={ellipse3}
                  alt="ellipse"
                />
                <QueryForm history={history} />
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
export default QuerySec;
